/**
 * Which SSH keypair a create form opens with, so it never opens on an empty "Select keypair…"
 * (Milos, 2026-10-27: the create form should come preselected).
 *
 * The keypair this browser last created a database with, if the account still has it; otherwise
 * the first one. Remembered in localStorage because it is a convenience, not a decision: a store
 * that is empty, blocked or holding another account's name just falls back to the first keypair,
 * and the field stays a one-click change either way.
 */
const LAST_KEYPAIR = 'redu.lastKeypair';

export const rememberKeypair = (name: string): void => {
    try { localStorage.setItem(LAST_KEYPAIR, name); } catch (_e) { /* private window or blocked storage */ }
};

export const defaultKeypair = <T extends { value: string }>(options: T[]): T | null => {
    let last: string | null = null;
    try { last = localStorage.getItem(LAST_KEYPAIR); } catch (_e) { /* fall back to the first */ }
    return options.find(o => o.value === last) ?? options[0] ?? null;
};
